export const removeTags = (html: string): string => {
  return html.replace(/(<([^>]+)>)/gi, "");
};

export const removeSpecificTag = (html: string, tag: string): string => {
  const regex = new RegExp("<" + tag + "[^>]+>[^<]+</" + tag + ">", "gi");
  return html.replace(regex, "");
};

export const containsHTML = (data: string) => {
  if (data.trim() === "") {
    return false;
  }
  const regex = new RegExp("<[a-z][^>]*>", "gi");
  return regex.test(data);
};
